import { useQuery } from '@tanstack/react-query';
import { useStudioClient } from '../context';
import { parseApiError } from '../errors';

/**
 * `GET /api/me` — reflects the authenticated session. Returns
 * `{ userId, workspaceId }`. The query is enabled by default; gate it on
 * `useAuth().isSignedIn` from Clerk in the consumer if needed (no point
 * firing the request before auth is resolved).
 */
export function useMe() {
  const client = useStudioClient();
  return useQuery({
    queryKey: ['me'],
    queryFn: async () => {
      const res = await client.api.me.$get();
      if (!res.ok) throw await parseApiError(res);
      return res.json();
    },
  });
}
